import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mb-4" }
const _hoisted_2 = { class: "text-center text-raleway-13 ml-2 mr-2" }
const _hoisted_3 = { class: "form-wrapper mt-4" }
const _hoisted_4 = { class: "uppercase text-raleway-13" }
const _hoisted_5 = {
  key: 0,
  class: "text-raleway-13 t-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "text-raleway-13 t-danger"
}
const _hoisted_7 = { class: "text-raleway-13 text-center t-accept" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = {
  class: "btn btn-default mt-4 m-auto",
  type: "submit"
}

import { ChangePassword } from '@/utils/validation/changePassword'
import { change } from '@/hook/change/change'
import { ref, computed, watch, onBeforeMount } from 'vue'
import { EmailType } from './type'
import { store } from '@/store'
import { SeoDescription, SeoTitle } from '@/utils/seo/seo'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeComponent',
  setup(__props) {

const errorRequred = ref<boolean>(false)
const dataInput = ref<EmailType>({email: ''})
const errorFetch = ref(computed<boolean>(() => store.getters.errorGetChange))
const notificationMessage = ref(computed<string>(() => store.getters.dataGetChange))
const errorFetchMessage = ref(computed<string>(() => store.getters.messageGetChange))

const ch = (event: Event) => change<EmailType>(event, dataInput)

const changePassword = async (event: Event) => {
    event.preventDefault()
    ChangePassword(dataInput, errorRequred)
}

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang))
watch(() => uiLang.value, () => {
    switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoTitle('Tyre point: ändra lösenord')
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoTitle('Tyre point: Vaihda salasana')
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoTitle('Tyre point: Change password')
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
}, {
    deep: true,
})

onBeforeMount(() => {
    const uiLang = ref(computed<string>(() => store.getters.getUserUiLang))

    switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoTitle('Logga in')
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoTitle('Tyre point: Kirjaudu sisään')
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoTitle('Tyre point: Login')
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form change-form",
    onSubmit: changePassword
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc('Forgot password')) + "?", 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc('forgot_password_text')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["input-wrapper mb-2", { 'error-input': errorRequred.value }])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('USERNAME OR EMAIL')), 1),
        _createElementVNode("input", {
          onInput: ch,
          type: "text",
          name: "email",
          class: "input"
        }, null, 32)
      ], 2),
      (errorRequred.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$tc('error_logins')), 1))
        : _createCommentVNode("", true),
      (errorFetch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorFetchMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tc(notificationMessage.value)), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$tc('reset_password')), 1)
      ])
    ])
  ], 32))
}
}

})